<template>
  <div>
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a
          @click="handleStep('medicine')"
          :class="[
            'nav-link link-nav-resident',
            step == 'medicine' && 'active',
          ]"
          id="nav-medicine"
          data-toggle="tab"
          href="#medicine"
          role="tab"
          aria-controls="medicine"
          aria-selected="true"
          >MEDICAMENTO</a
        >
        <a
          @click="handleStep('product')"
          :class="['nav-link link-nav-resident', step == 'product' && 'active']"
          id="nav-product"
          data-toggle="tab"
          href="#product"
          role="tab"
          aria-controls="product"
          aria-selected="true"
          >PRODUTO</a
        >
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div
        v-if="step == 'medicine'"
        :class="['tab-pane fade', step == 'medicine' && 'show active']"
        id="medicine"
        role="tabpanel"
        aria-labelledby="nav-medicine"
      >
        <medicine />
      </div>
      <div
        v-if="step == 'product'"
        :class="['tab-pane fade', step == 'product' && 'show active']"
        id="product"
        role="tabpanel"
        aria-labelledby="nav-product"
      >
        <product />
      </div>
    </div>
  </div>
</template>

<script>
import Medicine from "./sale/medicine";
import Product from "./sale/product";

import routes from "../../../../routes";

export default {
  name: "Create",

  components: {
    Medicine,
    Product,
  },

  created() {
    this.retrieve();
  },

  data() {
    return {
      step: "medicine",

      resident_id: "",

      errors: [],
    };
  },

  watch: {
    $route(to, from) {
      if (JSON.stringify(to.query) !== JSON.stringify(from.query)) {
        this.retrieve();
      }
    },
  },

  methods: {
    handleStep(step) {
      let { tab, menu, sale, action } = routes.history.current.query;

      if (sale != step) {
        routes.replace({ query: { tab, menu, sale: step, action } });
      }

      this.step = step;
    },

    retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;

      let { tab, menu, sale, action } = this.$router.currentRoute.query;

      if (!sale) {
        this.$router.replace({
          query: { tab, menu, sale: "medicine", action },
        });
        this.step = "medicine";
      } else {
        if (["medicine", "product"].includes(sale)) {
          this.step = sale;
        } else {
          this.step = "medicine";
        }
      }
    },
  },
};
</script>